export default __webpack_public_path__ + "static/media/after-effects.16f048ca.svg";